import { useGetRisksRiskDirectoryIdSuspense } from "api/generated/risks/risks";

type ISOTimestamp = string;
export function useRiskDirectoryViewQuery(id: string, at?: ISOTimestamp) {
    return useGetRisksRiskDirectoryIdSuspense(
        Number(id),
        at ? { at } : undefined,
        {
            query: { select: (response) => response.data },
        }
    );
}
